<template>
  <div>
    <el-card
      shadow="never"
      style="margin-bottom: 10px"
      :body-style="{
        padding: '15px 15px 0 15px',
      }"
    >
      <div class="mb-4 d-flex head-wrapper__container">
        <div class="img__container">
          <el-image
            :src="detailData.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              detailData.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 110px; height: 73px"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 110px; height: 73px"
              />
            </div>
          </el-image>
        </div>
        <div class="table__container">
          <div class="row__container">
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_tracking_no') || '选品款号' }}
              </div>
              <div class="various_value">{{ detailData.devTrackingNo }}</div>
            </div>
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_customer') || '选品客户' }}
              </div>
              <div class="various_value">{{ detailData.custName }}</div>
            </div>
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_selector') || '选品人' }}
              </div>
              <div class="various_value">{{ detailData.createByName }}</div>
            </div>
          </div>
          <div class="row__container">
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_sample_name') || '产品名称' }}
              </div>
              <div class="various_value">
                <div class="product__name">
                  <div style="display: flex; align-items: center; height: 39px">
                    <span style="max-height: 39px"
                      >{{ detailData.sampleName }}
                      {{ detailData.sampleNameEn }}</span
                    >
                  </div>
                  <div
                    class="tag"
                    :class="{
                      isSingle: detailData.isSingle == 'Y',
                      group: detailData.isSingle == 'N',
                    }"
                  >
                    {{ detailData.v_isSingle }}
                  </div>
                </div>
              </div>
            </div>
            <div class="various" style="flex: none; width: 314px">
              <div class="various_label">
                {{ $l('various_label_sample_style_no') || '原始样品款号' }}
              </div>
              <div class="various_value wx-200">
                {{ detailData.proposalStyleNo }}
              </div>
            </div>
          </div>
          <div class="row__container">
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_business_development') || '业务开发' }}
              </div>
              <div class="various_value">
                {{ detailData.devByName }}
              </div>
            </div>
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_select_date') || '选品时间' }}
              </div>
              <div class="various_value mw-100">
                {{ detailData.createDate }}
              </div>
            </div>
            <div class="various" style="flex: none">
              <div class="various_label">
                {{ $l('various_label_dev_status') || '业务状态' }}
              </div>
              <div class="various_value" style="width: 90px">
                {{ detailData.v_devStatus }}
              </div>
            </div>
            <div class="various">
              <div class="various_label">
                {{ $l('various_label_modify_date') || '更新时间' }}
              </div>
              <div class="various_value mw-100">
                {{ detailData.modifyDate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SearchTabs v-model="activeName" />
    </el-card>

    <TrackTab v-if="activeName == 'Track'" :devTrackingCode="devTrackingCode" />
    <FabricProofing
      v-if="activeName == 'FabricProofing'"
      :devTrackingCode="devTrackingCode"
    />
    <ProductProofing v-if="activeName == 'ProductProofing'" />
    <div v-if="activeName === 'Quotation'">
      <QuotationRecord
        :devTrackingCode="devTrackingCode"
        :detailData="detailData"
      ></QuotationRecord>
    </div>
    <div v-if="activeName === 'SampleSending'">
      <SampleSending
        :detailData="detailData"
        :devTrackingCode="devTrackingCode"
      />
    </div>
    <div v-if="activeName === 'ProductTesting'">
      <ProductTest :detailData="detailData" />
    </div>
    <div v-if="activeName === 'PictureDocument'">
      <PictureDocument :devTrackingCode="devTrackingCode" />
    </div>
    <div v-if="activeName === 'OrderConfirmation'">
      <OrderConfirmation :detailData="detailData" />
    </div>
  </div>
</template>
<script>
import SearchTabs from '../search-tabs'
import ProductProofing from '../product-proofing'
import QuotationRecord from '../quotation-record'
import SampleSending from '../sample-sending'
import ProductTest from '../product-test'
import TrackTab from '../track'
import OrderConfirmation from '../order-confirmation'
import EditLoading from '@/mixins/edit-loading'
import FabricProofing from '../fabric-proofing'
import PictureDocument from '../picture-document'
export default {
  components: {
    SearchTabs,
    TrackTab,
    ProductProofing,
    QuotationRecord,
    SampleSending,
    ProductTest,
    FabricProofing,
    PictureDocument,
    OrderConfirmation,
  },
  mixins: [EditLoading],
  props: {
    devTrackingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      activeName: 'Track',
      detailData: {},
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
    },
    getData() {
      if (!this.devTrackingCode) return
      this.$api
        .masterCustomerDevTrackingDetailApi({
          devTrackingCode: this.devTrackingCode,
        })
        .then((res) => {
          this.detailData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.head-wrapper__container {
  height: 120px;
  width: 100%;
  .img__container {
    width: 130px;
    height: 120px;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    border: 1px solid #efefef;
    border-right: none;
  }
  .table__container {
    height: 120px;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #efefef;
    .row__container {
      display: flex;
      height: 40px;
      border-bottom: 1px solid #efefef;
      .various {
        display: flex;
        flex: 1;
        .various_label {
          padding-left: 10px;
          width: 100px;
          background-color: #fafafa;
          color: #999a9f;
          font-size: 13px;
          display: flex;
          align-items: center;
          border-right: 1px solid #efefef;
        }
        .various_value::-webkit-scrollbar {
          display: none;
        }
        .various_value {
          overflow: -moz-scrollbars-none;
          padding: 0 0 0 10px;
          display: flex;
          align-items: center;
          flex: 1;
          font-size: 13px;
          color: #4f4f4f;
          align-content: center;
          border-right: 1px solid #efefef;
          overflow: scroll;
          -ms-overflow-style: none;
          .product__name {
            display: flex;
            height: 39px;
            justify-content: space-between;
            align-items: center;
            flex: 1;
            .tag {
              border-radius: 5px;
              padding: 3px 15px;
              height: 25px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
              font-weight: 600;
              width: 56px;
              flex: none;
              margin-right: 10px;
            }
            .isSingle {
              background-color: #e7f1fe;
              color: #307af9;
            }
            .group {
              background-color: #e99d42;
              color: #ffffff 100%;
            }
          }
        }
      }
      > .various:last-child {
        .various_value {
          border-right: none;
        }
      }
    }
    > .row__container:last-child {
      border-bottom: none;
    }
  }
}
.wx-200 {
  max-width: 200px;
}
.mw-100 {
  min-width: 100px;
}
</style>
